/**
 * Overlay for giveaway prize media when the viewer is not a paying subscriber.
 *
 * Shows the prize as a blurred silhouette behind a bracketed lock panel rather
 * than covering it with a manila "CLASSIFIED" folder graphic. The redaction
 * stamp read as an error state and hid the fact that a real prize exists at
 * all; a visible silhouette preserves desire while still gating the detail.
 */
import React from 'react';
import { Lock } from 'lucide-react';

const ClassifiedPrizeMedia = ({ children, onUnlock }) => (
  <div className="relative overflow-hidden">
    {/* Prize silhouette — blurred enough to obscure the model, not the shape. */}
    <div className="absolute inset-0 overflow-hidden pointer-events-none select-none" aria-hidden="true">
      <div className="h-full w-full blur-[14px] brightness-[0.7] saturate-[0.6] [&_img]:!h-full [&_img]:!max-h-none [&_img]:object-cover [&_img]:p-0">
        {children}
      </div>
    </div>

    <div className="relative z-10 flex flex-col items-center justify-center gap-3 px-4 py-8 bg-theme-carbon/70">
      {/* No crop marks here — the parent card already carries them, and a
          nested set reads as stray artifacts. */}
      <div className="flex flex-col items-center gap-2 px-6 py-4">
        <Lock className="h-4 w-4 text-theme-bronze" aria-hidden="true" />
        <span className="label-tac">Classified Prize</span>
        <span className="text-xs text-theme-silver-light text-center max-w-[15rem]">
          Subscriber access required to view this drawing.
        </span>
      </div>

      {onUnlock && (
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onUnlock();
          }}
          className="btn-primary !my-0 !py-2.5 !px-6 text-sm font-semibold"
        >
          Unlock with Bronze
        </button>
      )}
    </div>
  </div>
);

export default ClassifiedPrizeMedia;
